export const SNACKBAR_TEXT = {
  SUCCESS: 'Success.',
  ERROR: 'An error has occurred.',
}
